import React from "react";
import { Routes, Route } from "react-router-dom";
import Layout from "../components/Layout";
import RequireAuth from "../components/RequireAuth";
import UserList from "../modules/user/UserList";
import UserDetail from "../modules/user/UserDetail";
import EditUser from "../modules/user/EditUser";
import AboutPage from "../components/AboutPage";

import BeatList from "../modules/beat/BeatList";
import AddBeat from "../modules/beat/AddBeat";
import EditBeat from "../modules/beat/EditBeat";

// YENİ: Song Request imports
import SongRequestList from "../modules/songRequest/SongRequestList";

// YENİ: SongV2 imports
import SongV2List from "../modules/songV2/SongV2List";
import SongV2Detail from "../modules/songV2/SongV2Detail";
import AddSongV2 from "../modules/songV2/AddSongV2";
import EditSongV2 from "../modules/songV2/EditSongV2";

// YENİ: Songsterr Parser imports
import SongsterrPage from "../modules/songsterr/SongsterrPage";

// Notification imports
import NotificationPage from "../modules/notifications/NotificationPage";

// YENİ: Dashboard imports
import DashboardPage from "../modules/dashboard/DashboardPage";

import LoginPage from "../modules/login/LoginPage";

export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />

      {/* Korumalı alan */}
      <Route
        element={
          <RequireAuth>
            <Layout />
          </RequireAuth>
        }
      >
        <Route path="/" element={<DashboardPage />} />

        {/* Dashboard */}
        <Route path="/dashboard" element={<DashboardPage />} />

        {/* User */}
        <Route path="/users" element={<UserList />} />
        <Route path="/users/:id" element={<UserDetail />} />
        <Route path="/users/:id/edit" element={<EditUser />} />

        {/* Beat */}
        <Route path="/beats" element={<BeatList />} />
        <Route path="/beats/add" element={<AddBeat />} />
        <Route path="/beats/edit/:id" element={<EditBeat />} />

        {/* Song Requests - Separate from Songs */}
        <Route path="/song-requests" element={<SongRequestList />} />

        {/* SongsV2 - Drum Charts */}
        <Route path="/songsv2" element={<SongV2List />} />
        <Route path="/songsv2/:id" element={<SongV2Detail />} />
        <Route path="/songsv2/add" element={<AddSongV2 />} />
        <Route path="/songsv2/edit/:id" element={<EditSongV2 />} />

        {/* Songsterr Parser */}
        <Route path="/songsterr-parser" element={<SongsterrPage />} />

        {/* About */}
        <Route path="/about" element={<AboutPage />} />

        {/* Notification */}
        <Route path="/notifications" element={<NotificationPage />} />
      </Route>
    </Routes>
  );
}
